/**
 * A simple utility class to convert some constants to user friendly names
 */
import { PatternData, SeamRequest } from 'app/model';

import { CrisRequestType } from '../constants/cris-request-type';

export class Strings {
    public static patternType(type: CrisRequestType): string {
        switch (type) {
            case CrisRequestType.STORE:
                return 'Store';
            case CrisRequestType.CHANNEL:
                return 'Channel';
            case CrisRequestType.LOCATION:
                return 'Store Number';
            default:
                return 'Unknown';
        }
    }

    public static seamRequestType(request: SeamRequest): 'Map' | 'Unmap' {
        return request.correction ? 'Unmap' : 'Map';
    }

    public static patternDataNames(field: keyof PatternData | ''): string {
        switch (field) {
            case 'cityPattern':
                return 'City';
            case 'countryPattern':
                return 'Country';
            case 'descPattern':
                return 'Descriptor';
            case 'extractField':
                return 'Extract Field';
            case 'extractPattern':
                return 'Extract Pattern';
            case 'matchOperator':
                return 'Operator';
            case 'mccMatchOperator':
                return 'MCC Operator';
            case 'mccPattern':
                return 'MCC';
            case 'midPattern':
                return 'MID';
            case 'statePattern':
                return 'State';
            case 'subChannel':
                return 'Channel';
            case 'zipPattern':
                return 'Zip';
            case 'cobrander':
                return 'Cobr ID';
            default:
                return `Unknown ${field}`;
        }
    }
}
